<template>
  <PageContentLayoutOnly>
    <div>
      <ListArchitecturalRequestConversations
        :architecturalSubmissionID="parseInt(architecturalRequestID)"
      />
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ListArchitecturalRequestConversations from '@/pages/Shared/communications/Global/List'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'ArchitecturalRequestConversations',

  components: {
    PageContentLayoutOnly,
    ListArchitecturalRequestConversations
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {},

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { architecturalRequestConversations: { title: 'Conversations' } }
    }
  }
}
</script>

<style></style>
